<script lang="ts" setup>
import { ElMessage } from "element-plus"
import screenfull from "screenfull"
import { onUnmounted, ref } from "vue"

const props = defineProps({
  /** 全屏的元素，默认是 html */
  element: {
    type: String,
    default: "html",
  },
  /** 打开全屏提示语 */
  openTips: {
    type: String,
    default: "全屏",
  },
  /** 关闭全屏提示语 */
  exitTips: {
    type: String,
    default: "退出全屏",
  },
})

const tips = ref<string>(props.openTips)
const isFullscreen = ref<boolean>(false)
const supportsScreenfull = screenfull.isEnabled
  && typeof screenfull.on === "function"
  && typeof screenfull.off === "function"

const click = () => {
  const dom = document.querySelector(props.element) || undefined
  if (!supportsScreenfull) {
    ElMessage.warning("您的浏览器无法工作")
    return
  }
  screenfull.toggle(dom)
}

const change = () => {
  isFullscreen.value = screenfull.isFullscreen
  tips.value = screenfull.isFullscreen ? props.exitTips : props.openTips
}

if (supportsScreenfull) {
  screenfull.on("change", change)
}

onUnmounted(() => {
  if (supportsScreenfull) {
    screenfull.off("change", change)
  }
})
</script>

<template>
  <div @click="click" class="flex items-center">
    <!-- <el-tooltip effect="dark" :content="tips" placement="bottom">
      <svg-icon size="20px" :name="isFullscreen ? 'fullscreen-exit' : 'fullscreen'" />·
    </el-tooltip> -->
    <svg-icon size="20px" :name="isFullscreen ? 'fullscreen-exit' : 'fullscreen'" />
    <span ml-4px>{{ isFullscreen ? '退出全屏' : '全屏' }}</span>
  </div>
</template>
